import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Profile, User } from '@/api/types/common';

interface AuthState {
  // `token` is now nullable on the web. Cookie-auth logins do not return a
  // token; we treat the presence of `user` as the "logged in" predicate.
  token: string | null;
  user: User | null;
  profile: Profile | null;
  // Pending phone after OTP request, kept for the verify step.
  pendingPhone: { country_code: string; mobile_no: string } | null;
  setToken: (token: string | null, user?: User | null) => void;
  setProfile: (profile: Profile | null) => void;
  setPendingPhone: (p: AuthState['pendingPhone']) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      profile: null,
      pendingPhone: null,
      setToken: (token, user = null) => set({ token, user }),
      setProfile: (profile) => set({ profile }),
      setPendingPhone: (pendingPhone) => set({ pendingPhone }),
      clear: () => set({ token: null, user: null, profile: null, pendingPhone: null }),
    }),
    {
      name: 'partapp_auth',
      partialize: (s) => ({ token: s.token, user: s.user, profile: s.profile }),
    },
  ),
);

// Non-react getter for use inside axios interceptor.
export const authStore = useAuth;
